<template>
    <div v-if="isDisplay"
        :class="['preview-percentage-counter', formPercentage.positionIndex != maxComponent - 1 ? 'm-b-16' : '']">
        <div :class="['swift-percentage-counter in-app', formPercentage.position]">
            <div :class="['percentage-counter', formPercentage.position, formPercentage.size]">
                <p :style="'color: ' + formPercentage.color" :class="['fw-' + formPercentage.fontWeight, 'fz-'+formPercentage.size]"> {{percent}}% </p>
            </div>
        </div>
    </div>
</template>
<script>
import { listComponentDefault } from './../../constant'
export default {
    name: "PreviewPercentageCounter",
    props: {
        value: {
            type: Object,
            required: true,
        },
        isDisplay: {
            type: Boolean,
            required: true
        },
        percent: {
            type: Number,
            default: 0
        }
    },
    computed: {
        formPercentage: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit("input", this.value);
            },
        },
        maxComponent() {
            return listComponentDefault.length
        }
    },
    data() {
        return {
        };
    },

    created() {},
};
</script>

<style lang="scss">
    .swift-percentage-counter {
    }
</style>
